import { Injectable } from '@angular/core';
import { Directionality } from '@angular/cdk/bidi';

@Injectable()
export class NbDirectionality extends Directionality {}
